import { useState, useEffect } from "react";

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  

  useEffect(() => {
    // Handler, der bei jedem Resize aufgerufen wird
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Event Listener hinzufügen
    window.addEventListener('resize', handleResize);
    
    // Sofort aufrufen, um initialen Wert zu setzen
    handleResize();

    // Aufräumen: Listener entfernen, wenn die Komponente unmountet
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Leeres Array sorgt dafür, dass Effekt nur einmal läuft

  return windowSize;
}